'use strict';

import { observable, action, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import planItemStore from "./PlanItemStore";
import events from '@uw-it-sis/lib-react/lib/Events';
import PlanEvents from './PlanEvents';

class RemoveCourseFromPlanFormStore {
    removing = false;

    submitted = false;

    constructor() {
        makeObservable(this, {
            removing: observable,
            submitted: observable,
            mount: action,
            removeCourse: action,
            finishPlanItemRemove: action,
            errorPlanItemremove: action
        });
    }

    /**
     * initialize ( or reset ) internal state to initial
     */
    mount(planItemId) {
        this.submitted = false;
        this.removing = false;
        this.removeFailedMessage = "";
        this.planItemId = planItemId;

        events.listen(PlanEvents.planItemRemoved, (eventObject) => {
            if (eventObject.planItemId === this.planItemId) {
                this.finishPlanItemRemove();
            }
        });

        events.listen(PlanEvents.planItemError, (eventObject) => {
            if (eventObject.planItemId === this.planItemId) {
                this.errorPlanItemremove(eventObject.errMessage);
            }
        });
    }

    unmount() {
        events.remove(PlanEvents.planItemUpdated, (eventObject) => {
            if (eventObject.planItemId === this.planItemId) {
                this.finishPlanItemRemove();
            }
        });

        events.remove(PlanEvents.planItemError, (eventObject) => {
            if (eventObject.planItemId === this.planItemId) {
                this.errorPlanItemremove(eventObject.errMessage);
            }
        });
    }

    removeCourse() {
        this.removeFailedMessage = undefined;
        this.removing = true;
        this.submitted = true;

        planItemStore.remove(this.planItemId);
    }

    finishPlanItemRemove() {
        this.removing = false;
    }

    errorPlanItemremove(errorMessage) {
        this.removeFailedMessage = errorMessage;
        this.removing = false;
    }

    isRemoving() {
        return this.removing;
    }

    isSubmitted() {
        return this.submitted;
    }

    getRemoveFailedMessage() {
        return this.removeFailedMessage;
    }
}

export default new RemoveCourseFromPlanFormStore();